"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function Section({ children, style, title, ...props }) {
    return ((0, jsx_runtime_1.jsxs)("fieldset", { ...props, style: { border: "1px solid #6b5b3e", margin: "20px 0 0", padding: 12, ...style }, children: [(0, jsx_runtime_1.jsx)("legend", { style: { color: "#ff981f", padding: "0 6px" }, children: title }), (0, jsx_runtime_1.jsx)("div", { style: { alignItems: "center", display: "grid", gap: "10px 16px", gridTemplateColumns: "minmax(0, 1fr) auto" }, children: children })] }));
}
exports.Section = Section;
